import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { abpnClient } from "../../Services/AbpnClient";
import { AuthContext } from "../Auth/AuthProvider";
import Physician from "../Physician/Models/Physician";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import SecurityCard from "./SecurityCard";
import PersonalCard from "./PersonalCard";
 import MedicalLicensure from "../Dashboard/ContinuingCertification/Components/MedicalLicensure";
 import { MedicalLicense } from "../Physician/Models/MedicalLicense";
import AddressesCard from "./AddressesCard";
import { deepCopy } from "../Shared/Utility/DeepCopy";
import { CCBlock } from "../Physician/Models/CCBlock";
import PhysicianDemographicCard from "./PhysicianDemographicCard";
import { CountryId } from "../Shared/Enums/CountryId";

export default function AccountInformation() {
	const [physician, setPhysician] = useState<Physician>(null);
	const states = physician?.addresses.states.filter(x => x.countryId === CountryId.Usa || x.countryId === CountryId.Canada);

	const authContext = useContext(AuthContext);
	useEffect(() => {
		abpnClient.get<Physician>("/api/physician", authContext).then((_) => {
			setPhysician(_);
		});
	}, []);


	const evaluateCurrentBlockAndCallUpdate = async (physician : Physician) =>{
        const ccBlock = await abpnClient.get<CCBlock>("/api/physician/EvaluateCurrentBlockRequirements", authContext);

		if(ccBlock != null){
			var index = physician.currentCCEnrollment.ccBlocks.findIndex(_ => _.ccBlockId === ccBlock.ccBlockId);
			physician.currentCCEnrollment.ccBlocks.splice(index, 1, ccBlock);
			physician.currentCCEnrollment.currentCCBlock = ccBlock;
			setPhysician(physician);	
		}
    }
	const onSaveLicenses = (licenses: Array<MedicalLicense>) => {
        var updatedPhysician = deepCopy(physician);
        updatedPhysician.medicalLicenses = licenses;

        evaluateCurrentBlockAndCallUpdate(updatedPhysician);
    }

	if (!physician) return <AbpnSpinner />;
	return (
		<Container>
			<Row className="mb-4">
				<Col>
					<PersonalCard
							isSectionOpen={true}
							physician={physician}
							physicianId={physician.physicianId}
					/>
				</Col>
			</Row>
			<Row className="mb-4">
				<Col>
					<PhysicianDemographicCard
						isSectionOpen={true}
						physicianId={physician.physicianId}
					/>
				</Col>
			</Row>
			<Row className="mb-4">
				<Col>
					<SecurityCard
						isSectionOpen={true}
						physician={physician}
					/>
				</Col>
			</Row>
			<Row className="mb-4">
				<Col>
					<AddressesCard
						isSectionOpen={true}
						addresses={physician.addresses.addresses}
						physicianId={physician.physicianId}
						states={physician.addresses.states}
						countries={physician.addresses.countries}
					/>
				</Col>
			</Row>
			<Row className="mb-4">
				<Col>
					<MedicalLicensure
						isSectionOpen={true}
						medicalLicenses={physician.medicalLicenses}
						states={states}
						onSaveLicenses={(licenses: Array<MedicalLicense>) => onSaveLicenses(licenses)}
						showCollapse={true}
					/>
				</Col>
			</Row>
		</Container>
	);
}
